module.exports = __webpack_public_path__ + "static/media/produit-indispo.6a030801.png";